"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllPets = exports.updateTick = exports.update = exports.create = void 0;
var diveAstar_1 = require("@dive/astar/diveAstar");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var spritesCrew_1 = require("../dive/spriteRecyclers/spritesCrew");
var diveCrew_movable_sidecar_1 = require("./diveCrew_movable-sidecar");
var diveCrew_sidecar_1 = require("./diveCrew-sidecar");
function create() {
    var d = {
        moveTimer: 0,
        hasRolled: 0,
    };
    return d;
}
exports.create = create;
function update(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    if (obj.isDead || obj.isDying) {
        return;
    }
    diveCrew_movable_sidecar_1.diveCrew_movable.update(obj);
    // --- START DIVE
    // Render for dive
    var img = spritesCrew_1.spritesCrew.getNext(obj.x, obj.y, sprites_sidecar_1.sprites.diveMonsters20C16[0]);
    img.scaleX = obj.isFlipped ? -img.scaleX : img.scaleX;
    // --- END DIVE
}
exports.update = update;
function updateTick(obj) {
    if (obj.isDead || obj.isDying) {
        return;
    }
    // Test splatters
    // diveSplatters.createMultiple(1, obj.x + rando.i(-100, 100), obj.y)
    // console.log('pet path', !!obj.path)
    diveCrew_movable_sidecar_1.diveCrew_movable.updateTick(obj);
    // assert.notNil(obj.animalState)
    // if (obj.animalState.hasRolled < 5) {
    //   obj.animalState.hasRolled++
    // } else {
    //   obj.animalState.hasRolled = 0
    //   let ox = obj.rando.intSymmetric(5)
    // }
    if (obj.pathResult) {
        // Still moving
        return;
    }
    // TODO: randomly pick a move, with a sync'd rand
    // if (obj.moveTimer > 0) {
    //   obj.moveTimer -= 1
    // } else {
    var ox = obj.rando.intSymmetric(5);
    var oy = obj.rando.intSymmetric(5);
    var path = diveCrew_movable_sidecar_1.diveCrew_movable.sync_tryPathTo(obj, obj.i + ox, obj.j + oy, diveAstar_1.EDivePathToMode.On, false);
    diveCrew_movable_sidecar_1.diveCrew_movable.setNewPath(obj, path);
}
exports.updateTick = updateTick;
function getAllPets() {
    return diveCrew_sidecar_1.diveCrew.getAllFiltered(function (c) { return c.type === diveCrew_1.EVoyageCrewType.Pet; });
}
exports.getAllPets = getAllPets;
